<template>
  <div class="container">
    <div class="backImg">
      <div class="showMessage">
        <div class="b-template-preview">
          <div class="like-iphone">
            <div class="like-iphone-header"></div>
            <div class="like-iphone-bg" data-spm-anchor-id="5176.12213096.0.i4.43721cbeHfuaec">
              <div class="like-iphone-msg">
                {{messagecontents}}
                <div class="corner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    contents: '',
  },
  watch: {
    contents: 'changeContents',
  },
  data() {
    return {
      messagecontents: '',
    }
  },
  mounted() {
    this.messagecontents = this.contents
  },
  methods: {
    changeContents() {
      this.messagecontents = this.contents
    },
  },
}
</script>

<style scoped>
.like-iphone {
  width: 230px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-bottom: none;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.like-iphone .like-iphone-header {
  border: 1px solid #ddd;
  border-radius: 10px;
  margin: 25px auto;
  width: 40px;
  height: 5px;
}
.like-iphone .like-iphone-bg {
  overflow-x: hidden;
  overflow-y: auto;
  margin: 20px 5px 0;
  min-height: 170px;
  border: 1px solid #ddd;
  border-bottom: none;
  overflow: hidden;
}
.like-iphone .like-iphone-msg {
  position: relative;
  background: #e6e7ec;
  border-radius: 15px;
  margin: 20px 20px 0;
  min-height: 40px;
  padding: 10px;
  line-height: 20px;
  word-break: break-all;
  overflow-wrap: break-word;
}
.like-iphone .like-iphone-msg .corner {
  position: absolute;
  bottom: -1px;
  left: -9px;
  width: 25px;
  height: 15px;
  background: url(https://img.alicdn.com/tfs/TB1NpdyNpXXXXa3apXXXXXXXXXX-28-17.png) no-repeat 0 0;
}
</style>